export default {
  modal: 7000,
  skipToMain: 6000,
  headerActive: 5000,
  cookiesConsent: 4000,
  header: 1000,
  speciesFilter: 500,
}
